import type { SelectableField } from "../types";

const normalize = (value: string): string => value.toLowerCase().replace(/[^a-z0-9]/g, "");

interface DatasourceOverride {
    match: string[];
    target: string;
}

const OVERRIDES: DatasourceOverride[] = [
    { match: ["rds"], target: "product line" },
    { match: ["pdc exception", "failed sensor"], target: "frame family" },
    { match: ["support emails"], target: "product line" },
    { match: ["prod support archive", "fault reports"], target: "machine type" },
];

const PRIORITY_KEYWORDS = [
    "product type",
    "content type",
    "product line",
    "frame family",
    "machine type",
    "document type",
    "report type",
];

const findByLabel = (fields: SelectableField[], target: string): SelectableField | undefined => {
    const wanted = normalize(target);
    return (
        fields.find((field) => normalize(field.label) === wanted) ??
        fields.find((field) => normalize(field.label).includes(wanted))
    );
};

export const resolveDefaultCategory = (
    datasourceLabel: string,
    fields: SelectableField[],
): string => {
    if (fields.length === 0) return "";

    const normalizedLabel = normalize(datasourceLabel);
    const override = OVERRIDES.find((entry) =>
        entry.match.some((phrase) => normalizedLabel.includes(normalize(phrase))),
    );
    if (override) {
        const matched = findByLabel(fields, override.target);
        if (matched) return matched.value;
    }

    for (const keyword of PRIORITY_KEYWORDS) {
        const matched = findByLabel(fields, keyword);
        if (matched) return matched.value;
    }

    const anyProduct = fields.find((field) => normalize(field.label).includes("product"));
    if (anyProduct) return anyProduct.value;

    return fields[0]?.value ?? "";
};
